<template>
  <div>
    <b-row>
      <b-col class="text-right">
        <a href="javascript:void(0)" class="text-decoration-none">
          <span class="see-more-link">{{ title }}</span>
        </a>
      </b-col>


    </b-row>

    <b-row class="my-5 justify-content-center">

       <span class="btn btn-secondary mt-1 mr-2 rounded-pill px-2" :class="{'btn-primary':('' == activeCategory)}"
             @click="filterProducts()">
         {{ firstCategory }}
       </span>

      <span class="btn btn-secondary mt-1 mr-2 rounded-pill px-2"

            v-for="category in categories" :key="category.id"
            v-if="category.products_count > 0"
            :class="{'btn-primary':(category.id == activeCategory)}"
            @click="filterProducts(category.id)">
        {{ category.name }}
      </span>
    </b-row>

    <b-col class="text-left mb-2">

      <router-link :to="{name:'Products',query:setQueryProduct}" class="text-decoration-none">
        <span>
          <b-icon-arrow-left class="custom-icon-font-size "/>
        </span>

        <span class="see-more-link">
            مشاهده همه
          </span>

      </router-link>
    </b-col>

    <swiper v-if="products.length > 0" ref="mySwiper" :options="swiperOptions" >
      <swiper-slide v-for="product in products" :key="product.id" class="p-2">
        <m-c104 :product="product" class="slider-card"/>
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
      <div class="swiper-button-prev" slot="button-prev"></div>
      <div class="swiper-button-next" slot="button-next"></div>
    </swiper>
  </div>
</template>

<script>
import {Swiper, SwiperSlide, directive} from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import {formatNumber} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";
import {mapGetters} from "vuex";
import {isProductActive} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Timing";
import {basketAddItem, addUnAuthItem} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/ShoppingCartFunctions";

export default {
  name: "Slider101",
  components: {Swiper, SwiperSlide, directive},
  props: {
    is_digital: {
      default: ''
    },
    title: {
      default: ''
    },
    firstCategory: {
      default: 'آخرین محصولات',
    },
    digitalShoppingCartBadge: {
      default: 'مشاهده و خرید',
    },
    physicalShoppingCartBadge: {
      default: 'مشاهده و خرید',
    },
  },
  data() {
    return {
      activeCategory: '',
      swiperOptions: {
        slidesPerView: 4,
        spaceBetween: 30,
        autoplay: {
          delay: 2000,
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
          dynamicBullets: true
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        breakpoints: {
          100: {
            slidesPerView: 1,
          },
          500: {
            slidesPerView: 1,
          },
          600: {
            slidesPerView: 2,
          },
          765: {
            slidesPerView: 2,
          },
          980: {
            slidesPerView: 3,
          },
          1200: {
            slidesPerView: 4,
          }
        }
      },
    };
  },
  computed: {
    ...mapGetters({
      products: "Product/getProducts",
      categories: 'Category/getCategories'
    }),
    IsAuthenticated() {
      return this.$store.getters["User/isAuthenticated"];
    },
    setQueryProduct() {
      return this.activeCategory !== '' ? {category: this.activeCategory} : {};
    }
  },
  methods: {
    formatNumber,
    isProductActive,
    basketAddItem,
    addUnAuthItem,
    filterProducts(category) {
      if (category > 0) {
        this.activeCategory = category;
        this.$store.commit('Product/setFilters', {key: 'category', value: [category]})
        this.$store.dispatch("Product/setProducts", 1)
      } else {
        this.activeCategory = '';
        this.$store.commit('Product/setFilters', {key: 'category', value: []})
        this.$store.commit('Product/setFilters', {key: 'sort', value: ''})
        this.$store.dispatch("Product/setProducts", 1)
      }
    },

  },
  mounted() {
    this.$store.dispatch('Category/getCategories')
    this.$store.commit('Product/setFilters', {key: 'category', value: []})
    this.$store.commit('Product/setFilters', {key: 'brand', value: []})
    this.$store.commit('Product/setFilters', {key: 'sort', value: ''})
    this.$store.commit('Product/setFilters', {key: 'is_digital', value: this.is_digital})
    this.$store.dispatch("Product/setProducts");
  }
};
</script>

<style scoped>
.see-more-link {
  color: var(--primary);
  font-size: 19px;
  font-weight: bold;
}
.slider-card{
  max-height: 500px !important;
}

</style>